<template>
    <CieloLayout :show-merchant-name="true">
        <div class="identification">
            <div class="identification__form">
                <h4 class="identification__title" v-text="$ml.get('identificationTitle')" tabindex="0" />
                <CieloInputV2
                    class="identification__input"
                    :autofocus="false"
                    :borderless="false"
                    name="Email"
                    :label="$ml.get('email')"
                    v-model="email"
                    v-validate="'required|safe-mail'"
                    :data-vv-as="$ml.get('email')"
                    type="email"
                    :error="errors.first('Email')"
                />
                <span class="identification__info" v-text="$ml.get('identificationText')" />
            </div>
        </div>

        <RecurringPaymentWarning />

        <CieloButtonV2
            class="identification__button"
            :loading="buttonIsLoading"
            @click="goToNextPage"
            aria-label="$ml.get('continue')"
        >
            <span :style="{ 'font-weight': 600, 'font-size': '16px' }" v-text="$ml.get('continue')" />
        </CieloButtonV2>
    </CieloLayout>
</template>

<script>
	import SafeMailValidation from '@/helpers/validation-rules/SafeMailValidation';

	const CieloLayout = () => import(
		/* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
	);

	const CieloInputV2 = () => import(
        /* webpackChunkName: "cielo-input" */ '@/components/ClickToPay/template/CieloInputV2'
	);

	import CieloButtonV2 from '@/components/template/CieloButtonV2.vue';

	import RecurringPaymentWarning from '@/components/RecurringPaymentWarning';

	export default {
		components: {
			CieloLayout,
			CieloInputV2,
			CieloButtonV2,
			RecurringPaymentWarning
		},

		computed: {
			email: {
				get: (self) => self.$store.state.customer.Email,
				set(value) {
					this.$store.commit('customer/setEmail', value);
				},
			},
		},

		mounted() {
            this.$validator.extend('safe-mail', SafeMailValidation);
            this.$validator.validate();
        },

		data() {
			return {
				buttonIsLoading: false,
			};
		},

		methods: {
			async goToNextPage() {
				if (this.buttonIsLoading) return;

				this.buttonIsLoading = true;

				const isValid = await this.$validator.validateAll();

				if (!isValid) {
					this.buttonIsLoading = false;
					return;
				}

				try {
					await this.$store.dispatch('dataOnFile/sendOtp', this.email);
					this.$store.dispatch('pipelineV2/pushNext');
				} catch (error) {
					console.error('::Error::', error);
				} finally {
					this.buttonIsLoading = false;
				}
			},
		}
	};
</script>

<style lang="scss" scoped>
	.identification {
		@media screen and (max-width: 1024px) {
			display: flex;
			flex-direction: column;
			flex: 1 1 auto;
		}
		&__form {
			width: 100%;
			margin-bottom: 24px;
		}

		&__title {
			font-size: 20px;
			font-weight: 700;
			line-height: 28px;
			color: #2F363E;

			margin-bottom: 20px;
		}

		&__input {
			margin-bottom: 12px;
		}

		&__info {
			font-size: 14px;
			font-weight: 500;
			line-height: 20px;
			color: #454F5C;
		}

		&__button {
			width: 100%;
			height: 44px;

			display: flex;
			justify-content: center;
			align-items: center;

			border-radius: 32px;

			&:hover {
				background-color: #0D5FC0;
			}
		}
	}
</style>
